export default {
    'edit-classification': 'تعديل التصنيف',
    'add-new-classification': 'إضافة تصنيف جديد'
}